{
  "user": {
    "addToDigitalWallet": {
      "cardTitle": "Your Digital Membership Card",
      "cardSubtitle": "Includes all active memberships {'&'} auto-updates",
      "downloadPdf": "Download PDF",
      "autoUpdates": "Automatically updates when memberships change",
      "cardDescription": "Every active membership, on your phone — it updates itself automatically.",
      "addToAppleWallet": "Add to Apple Wallet",
      "addToGoogleWallet": "Add to Google Wallet"
    },
    "addressPrice": {
      "priceReason": "You're seeing this price because of your address."
    },
    "displayMembershipCard": {
      "eligibleForEarlyRenewal": "Eligible for early renewal",
      "renewNow": "Renew now →",
      "paymentFailed": "Payment Failed",
      "updateYourCardIn": "Update your card in",
      "paymentSettings": "Payment Settings",
      "nextAttempt": "· Next attempt:",
      "active": "Active",
      "noExpiration": "No expiration",
      "members": "Members",
      "person": "person",
      "people": "people",
      "manageWhoUsesThisMembership": "Manage who uses this membership",
      "notAvailableForThisPlan": "Not available for this plan",
      "autoRenew": "Auto-renew",
      "renewsOnAtNoCharge": "Renews on {date} at no charge",
      "renewManuallyBefore": "Renew manually before {date}",
      "addPaymentMethodToEnable": "Add a payment method to enable",
      "renewsOnFor": "Renews on {date} for {price}",
      "includesMembershipFee": "(includes {fee} membership fee)",
      "autoRenewNotAvailable": "Auto-renew is not available for this membership",
      "whoUsesThisMembership": "Who uses this membership?",
      "chooseWhoReceivesBenefits": "Choose who receives the benefits of this membership.",
      "thisMembershipCovers": "This membership covers",
      "onePerson": "1 person",
      "eitherYouOrFamilyMember": "— either you or a family member.",
      "thisMembershipCoversUpTo": "This membership covers up to",
      "totalIncludingYourself": "total, including yourself.",
      "spotUsed": "spot used",
      "spotsUsed": "spots used",
      "removeSomeoneToAddAnother": "Remove someone to add another",
      "accountHolder": "Account Holder",
      "iUseThisMembershipMyself": "I use this membership myself",
      "youWontReceiveBenefits": "You won't receive membership benefits. All spots go to your family members.",
      "familyMembers": "Family Members",
      "addNew": "Add new",
      "noFamilyMembersYet": "No family members yet.",
      "addAFamilyMember": "Add a family member",
      "toShareThisMembership": "to share this membership.",
      "changeRenewalStatus": "Change Renewal Status",
      "enableAutomaticRenewalFor": "Enable automatic renewal for {name}",
      "youPlus": "You + {names}",
      "you": "You",
      "noOneSelected": "No one selected",
      "failedToUpdateMembers": "Failed to update members. Please try again.",
      "renewalStatusUpdated": "Renewal status updated!",
      "failedToUpdateRenewalStatus": "Failed to update renewal status. Please try again.",
      "updateYourCard": "Update your card →",
      "nextAttemptLabel": "Next attempt",
      "addMembers": "Add members",
      "manageMembers": "Manage members",
      "noOneAddedYet": "No one added yet",
      "providedViaProvider": "via {provider} · Family group",
      "providedViaFamilyGroup": "via your family group"
    },
    "membershipCard": {
      "earlyRenewal": "Early Renewal",
      "detailsTitle": "{name} Details",
      "startingAt": "Starting at"
    },
    "additionalMembers": {
      "whoElseAssociated": "Who else will be associated with this plan?",
      "selectFromExistingFamilyMembers": "Select from existing family members",
      "addMembersToYourAccount": "Add members to your account who will also be associated with this plan",
      "name": "Name",
      "email": "Email",
      "fullName": "Full name",
      "gender": "Gender",
      "male": "Male",
      "female": "Female",
      "add": "Add"
    },
    "membershipCreate": {
      "noMembershipsAvailable": "There are no memberships available for purchase at this time.",
      "availableMemberships": "Available Memberships"
    },
    "membershipIndex": {
      "myMemberships": "My Memberships",
      "memberId": "Your Member ID:",
      "noActiveMemberships": "No active memberships found.",
      "viewAvailableMemberships": "View available memberships",
      "noExpiredMemberships": "You have no expired memberships",
      "viewMemberships": "View Memberships",
      "active": "Active",
      "expired": "Expired"
    },
    "membershipTypeShow": {
      "title": "Complete Membership Selection",
      "backToMemberships": "Back to Memberships",
      "notFoundTitle": "Membership Not Found",
      "notFoundMessage": "This membership doesn't exist or is not available.",
      "viewAvailableMemberships": "View Available Memberships"
    },
    "flowMembershipPurchase": {
      "loadFormError": "Unable to load the membership form. Please refresh the page and try again.",
      "formValidationTimeout": "Form validation timed out. Please try again.",
      "addToCartError": "Unable to add membership to cart right now",
      "membershipAddedSuccess": "Membership added successfully",
      "freeSignupError": "Unable to complete free signup",
      "addAddonToCartError": "Unable to add membership to cart",
      "genericError": "An error occurred. Please try again."
    },
    "membershipPlanSelection": {
      "noPlansAvailable": "No plans are available for purchase. This could be because the street address on your account is not within the defined boundary of our organization.",
      "verifyAddressPrompt": "Ensure your address is accurate by visiting your account settings to verify and update it as needed.",
      "chooseAmount": "Choose An Amount",
      "howMuchToPay": "How much would you like to pay?"
    },
    "membershipReview": {
      "selectPlanPrompt": "Please select a membership plan to continue.",
      "yourSelection": "Your Selection",
      "earlyRenewalNotice": "Early renewal — starts when current membership ends",
      "total": "Total",
      "taxesNote": "Taxes calculated at checkout",
      "autoRenewTitle": "Auto-renew this membership",
      "autoRenewDescription": "Renews automatically when it expires. You can change this anytime from your account.",
      "basePlanFallback": "Membership Plan",
      "addonFallback": "Add-on"
    },
    "membershipTagSelection": {
      "noTagsAvailable": "No volunteer interest tags are available."
    },
    "badgeMembershipRequired": {
      "membershipRequired": "Membership required"
    }
  },
  "manager": {
    "membershipSelect": {
      "membershipType": "Membership Type",
      "selectOneOrMore": "Select one or more",
      "typesSelected": "{count} types selected",
      "noMembership": "No membership",
      "allUsers": "All Users"
    },
    "moveMembershipModal": {
      "title": "Move Membership",
      "move": "Move",
      "noMembershipsAvailable": "There are no memberships available to move this user to. Create a new membership to get started.",
      "movePrompt": "Select the membership and plan you would like to move {count} users to.",
      "membershipType": "Membership Type",
      "plan": "Plan",
      "note": "Note:",
      "maintainsDatesNote": "This will maintain the original membership start date, expiration date, and auto-renewal status.",
      "selectMembership": "Select Membership",
      "selectPlan": "Select Plan"
    },
    "createOrEditPlan": {
      "detailsSection": "Details",
      "planNameLabel": "Plan Name *",
      "planNameFeedback": "This field is required and must be 191 characters or less.",
      "planNamePlaceholder": "Enter a name for this plan",
      "planDescriptionLabel": "Plan Description",
      "planDescriptionHint": "Max 250 characters.",
      "planDescriptionFeedback": "This field must be 250 characters or less.",
      "planDescriptionPlaceholder": "Enter a description for this plan",
      "pricingSection": "Pricing",
      "typeLabel": "Type *",
      "typeCostFeedback": "You must provide a cost when the plan type is Fixed Pricing.",
      "priceEditingLocked": "Price editing is currently locked.",
      "contactSupportForPricing": "Contact support to modify pricing for this plan.",
      "userSpecifiesNote": "Note: When 'User specifies' is selected, users will not be able to setup automatic renewals for this plan.",
      "lifetimeNote": "Note: 'Free Lifetime' plans cannot be purchased by users. They can only be assigned by an administrator and will persist until cancellation by an administrator.",
      "billingFrequencyLabel": "Billing Frequency *",
      "billingFrequencyDescription": "How often the user will be billed.",
      "monthly": "Monthly",
      "yearly": "Yearly",
      "boundariesSection": "Boundaries",
      "associatedBoundaryLabel": "Associated Boundary",
      "associatedBoundaryDescription": "Users will only see this plan if their address is within the selected boundary.",
      "controlPlanDisplayLabel": "Control Plan Display",
      "controlPlanDisplayDescription": "Select a plan to hide when the current plan is displayed to the user.",
      "membershipSettingsSection": "Membership Settings",
      "beneficiariesLabel": "Membership Beneficiaries *",
      "beneficiariesDescription": "Controls how many people can benefit from this plan.",
      "accountHolderOnly": "Account holder only",
      "limitedNumberOfPeople": "Limited number of people",
      "unlimited": "Unlimited",
      "maxPeopleLabel": "Maximum number of people",
      "accountHolderHint": "This includes the account holder. If set to 1, the account holder can assign the membership to a family member instead.",
      "businessPlanDescription": "User will be required to enter a business address on checkout when purchasing this plan.",
      "fieldRequired": "This field is required.",
      "businessPlanCheckbox": "Plan is for businesses/corporations",
      "fixedPrice": "Fixed price",
      "userSpecifies": "User specifies",
      "freeLifetime": "Free Lifetime",
      "noBoundaryOption": "--- No Boundary ---",
      "noHiddenPlanOption": "--- No Hidden Plan ---",
      "editPlanTitle": "Edit Plan",
      "createPlanTitle": "Create Plan",
      "planUpdated": "Plan updated!",
      "membershipTypeNotFound": "Membership type not found.",
      "planCreated": "Plan created!",
      "somethingWentWrong": "Something went wrong! Please try again or contact support.",
      "planNotFound": "Plan not found.",
      "membershipTypeProductIdRequired": "Membership type product ID is required for creating a new plan.",
      "failedToLoadData": "Failed to load data. Please refresh the page."
    },
    "membershipSettings": {
      "title": "Membership Settings",
      "automaticCustomMembershipNumbers": "Automatic Custom Membership Numbers",
      "customNumbersDescription": "Define a range of membership numbers that users will be assigned upon successful membership purchase.",
      "membershipNumberPrefixLabel": "Membership Number Prefix *",
      "membershipNumberPrefixDescription": "A prefix that will be prepended to your membership number.",
      "fieldRequired": "This field is required.",
      "startingNumberLabel": "Starting Membership Number *",
      "startingNumberDescription": "Users will be assigned a custom membership number starting at this number.",
      "endingNumberLabel": "Ending Membership Number *",
      "endingNumberDescription": "Users will be assigned a custom membership number ending at this number.",
      "endingNumberRequiredFeedback": "This field is required and must be greater than the starting number.",
      "maintainMembershipNumber": "Maintain auto assigned membership number even after subscription expiration or cancellation.",
      "numbersPreviewStart": "Based on the parameters defined above, users will receive membership numbers starting at",
      "numbersPreviewEnd": "and ending at",
      "autoRenewalSettings": "Auto-Renewal Settings",
      "autoRenewalDescription": "Control the default state of the auto-renewal option presented to users when they sign up for or purchase a membership. Applies to both free and paid memberships.",
      "defaultAutoRenewalToEnabled": "Default auto-renewal to enabled",
      "autoRenewalHelp": "When enabled, the auto-renewal toggle will be pre-selected for both free and paid memberships. Users can still opt out before completing their purchase or signup.",
      "memberDirectory": "Member Directory",
      "memberDirectoryDescription": "Control whether members can view a directory of other members at your organization.",
      "enableMemberDirectory": "Enable member directory",
      "memberDirectoryHelp": "When enabled, members can view a directory of other members at your organization. Only member names are displayed for privacy.",
      "settingsEntity": "Settings",
      "autoRenewalSaveError": "Failed to save auto-renewal settings. Please try again.",
      "memberDirectorySaveError": "Failed to save member directory settings. Please try again."
    },
    "membershipsCreate": {
      "basicInformationTitle": "Basic Information",
      "membershipNameLabel": "Membership Name *",
      "nameRequiredFeedback": "This field is required",
      "namePlaceholder": "Enter a name for this membership",
      "membershipTypeLabel": "Membership Type *",
      "fieldRequiredFeedback": "This field is required.",
      "membershipTypeDescription": "Base memberships are required to be created before add-ons. An example of an Add-on membership could be a 'Tennis Court Membership' which could be tied to booking a tennis court.",
      "selectMembershipTypeOption": "--- Select a Membership Type ---",
      "baseOption": "Base",
      "addonOption": "Add-on",
      "selectBaseMembershipLabel": "Select your desired base membership",
      "baseRequiredFeedback": "This field is required when Add-on is selected.",
      "baseMembershipDescription": "Users will be required to purchase this base membership first or at the same time as this add-on.",
      "selectBaseMembershipOption": "--- Select a Base Membership ---",
      "addonVisibilityLabel": "Add-on Visibility",
      "addonVisibilityDescription": "When enabled, only members who already hold the selected base membership will see this add-on in purchase flows.",
      "hideAddonUnlessBase": "Hide this add-on unless the user has the selected base membership",
      "bundleWithBaseLabel": "Bundle with base membership",
      "bundleWithBaseDescription": "When enabled, only the combined base + add-on appears in member purchase and assign flows. The base membership is not listed on its own. Members who already have the base still add this add-on through that same combined entry.",
      "onlySellAsBundle": "Only sell as a bundle with the base (hide standalone base)",
      "membershipDescriptionLabel": "Membership Description *",
      "max250Description": "Max 250 characters.",
      "descriptionLengthFeedback": "Field is required and must be 250 characters or less.",
      "renewalSettingsTitle": "Renewal Settings",
      "renewalFrequencyLabel": "Renewal Frequency *",
      "specificDateOption": "Specific Date",
      "rollingOption": "Rolling",
      "endDateLabel": "End Date *",
      "endDateDescription": "When the user will be required to renew their membership.",
      "newEndDateTitle": "Important: New End Date Specified",
      "endDateChangedWarning": "The end date is being changed to a new date. Some users may have memberships that expire on the previous end date.",
      "endDateUpdatePrompt": "Do you want to update these existing memberships to expire on the new end date, or keep them set to expire on the previous end date?",
      "updateEndDatesLabel": "Update existing membership end dates:",
      "updateEndDatesFeedback": "A selection must be made when the end date is modified.",
      "daysBeforeExpirationLabel": "Days Before Expiration",
      "daysBeforeExpirationDescription": "The number of days before expiration that users can renew.",
      "numberFeedback": "This field must be a number",
      "userCanSetupAutoRenewal": "User can setup auto-renewal for this membership",
      "autoRenewalDisabledTitle": "Important: Auto-Renewal Disabled",
      "autoRenewalEnabledWarning": "Some users currently have memberships with auto-renewal enabled for this membership type.",
      "cancelAutoRenewalsPrompt": "Do you want to cancel all existing auto-renewals so they expire at the end of their current period?",
      "actionIrreversible": "This action is irreversible.",
      "cancelAutoRenewalsConsequence": "If you choose to cancel existing auto-renewals, affected memberships will not renew and this cannot be undone.",
      "cancelAutoRenewalsLabel": "Cancel existing auto-renewals:",
      "cancelAutoRenewalsFeedback": "A selection must be made when auto-renewal is disabled.",
      "notificationSettingsTitle": "Notification Settings",
      "emailPreExpiration": "Send an email to the user that their membership is about to expire",
      "daysBeforeExpirationEmailLabel": "Days before expiration to send email",
      "requiredWhenCheckedFeedback": "Required when checked. Must be numeric.",
      "emailPostExpiration": "Send an email reminding the user their membership has expired",
      "daysAfterExpirationEmailLabel": "Days after expiration to send email",
      "emailOnExpiration": "Send an email to the user when their membership expires",
      "disableDefaultCardEmail": "Disable the default membership card PDF email for this membership type",
      "additionalSettingsTitle": "Additional Settings",
      "customFormLabel": "Custom Form",
      "customFormDescription": "Select a form to collect additional information during the membership purchase. You can create membership forms in the Forms section.",
      "noFormOption": "--- No Form ---",
      "autoRenewalFormWarning": "Auto-renewal is enabled. When a membership auto-renews, the user will not be prompted to fill out the form again. Form responses cannot be guaranteed for auto-renewed memberships.",
      "waiverDescription": "The user will be forced to agree to the selected waivers before purchasing.",
      "selectWaiversLabel": "Select waivers",
      "excludeFromTax": "Exclude this membership from tax rates",
      "hiddenDescription": "Enabling this setting will prevent the membership from being purchasable by the public. As an administrator, you will still be able to assign this membership to users.",
      "hideFromPublic": "Hide this membership from the public",
      "hideStartingPriceDescription": "When enabled, public and member-facing membership pages will hide the starting price while keeping the membership selectable.",
      "hideStartingAtPrice": "Hide Starting At Price",
      "communalAdminSettingsTitle": "Communal Admin Settings",
      "excludeFromParentTenantFee": "Exclude this membership from parent tenant fee",
      "pageTitle": "Create Membership",
      "endDateBeforeTodayFeedback": "End date cannot be before today.",
      "endDateMaxFeedback": "End date must be within 2 years minus 1 day from today.",
      "updateHeader": "Update Membership",
      "createHeader": "Create Membership",
      "membershipTypeEntity": "Membership type",
      "saveError": "Something went wrong saving.",
      "noCardOption": "No card"
    },
    "membershipsIndex": {
      "membershipTypesTitle": "Membership Types",
      "reorder": "Reorder",
      "resetOrder": "Reset Order",
      "saveOrder": "Save Order",
      "loadItemsError": "Failed to load items for reordering.",
      "orderSaved": "Order saved. This is the order end users will see.",
      "saveOrderError": "Failed to save order.",
      "orderReset": "Manual order reset. End users now see the default order.",
      "resetOrderError": "Failed to reset to natural order."
    },
    "planIndex": {
      "plansTitle": "Plans",
      "membershipTypeFilterLabel": "Membership Type"
    },
    "manageMemberships": {
      "currentMembershipTypes": "Current Membership Types",
      "createNewMembershipType": "Create new membership type",
      "title": "Title",
      "description": "Description",
      "activeSignups": "Active signups",
      "editAddTiers": "Edit {'|'} Add tiers"
    },
    "digitalMembershipCard": {
      "basicInformation": "Basic Information",
      "titleTextLabel": "Title Text",
      "titleTextHelp": "Shown on Apple Wallet cards. Leave blank to use the default tenant name.",
      "hideAppleTitle": "Hide Apple Wallet title entirely",
      "googleTitleOverrideLabel": "Google Wallet Title Override",
      "googleTitleOverrideHelp": "Optional text shown only on Google Wallet passes. Leave blank to reuse the Title Text above.",
      "googleTitlePlaceholder": "Enter custom Google Wallet title",
      "googleTitleLabel": "Google Wallet Title",
      "googleTitleHelp": "When enabled, the Google Wallet card title will include the member ID (ID #123).",
      "includeMemberIdInGoogleTitle": "Include member ID in Google Wallet title",
      "logoTypeLabel": "Logo Type *",
      "logoTypeDefault": "Default",
      "logoTypeCustom": "Custom",
      "cardTypeLabel": "Apple Wallet Card Type *",
      "cardTypeGeneric": "Generic (Standard Membership Card)",
      "cardTypeStoreCard": "Store Card (Rewards/Points Style)",
      "uploadLogoLabel": "Upload Logo *",
      "uploadLogoHelp": "Recommended size: 160x160px. PNG format only. Max 10MB.",
      "logoInvalidFeedback": "The field is required and must be 10MB or less.",
      "appearanceColors": "Appearance & Colors",
      "cardBackgroundColorLabel": "Card Background Color *",
      "cardLabelColorLabel": "Card Label Color *",
      "cardTextColorLabel": "Card Text Color *",
      "colorsNote": "Note: Only Apple Wallet cards will use the label and text colors. Google Wallet cards will automatically use black or white depending on the background color.",
      "barcodeConfiguration": "Barcode Configuration",
      "showBarcodeLabel": "Show Barcode on Card",
      "showBarcodeHelp": "If disabled, the barcode will be omitted from both Apple and Google passes.",
      "showBarcode": "Show barcode",
      "barcodeValueTypeLabel": "Barcode Value Type *",
      "barcodeValueTypeDefault": "Default (Membership Details URL)",
      "barcodeValueTypeStatic": "Static Value",
      "barcodeValueTypeDynamic": "Dynamic User Field",
      "hideExpiryLabel": "Hide expiry date from card",
      "hideExpiryHelp": "When enabled, the expiry date and temporary expiry will be hidden from both Apple and Google Wallet cards.",
      "hideExpiry": "Hide expiry date",
      "membershipFieldLabel": "'Membership' field on card",
      "membershipFieldHelp": "Choose what is shown on the front of the card under the Membership label.",
      "membershipFieldPlan": "Plan name only",
      "membershipFieldType": "Membership type only",
      "membershipFieldBoth": "Both (membership type and plan name)",
      "staticBarcodeValueLabel": "Static Barcode Value *",
      "staticBarcodeValueHelp": "Enter the static value that will be encoded in the barcode.",
      "staticBarcodeValuePlaceholder": "Enter static value",
      "userFieldLabel": "User Field *",
      "userFieldHelp": "Select which user field to encode in the barcode.",
      "selectFieldOption": "Select a field",
      "memberIdOption": "Member ID",
      "barcodeFormatLabel": "Barcode Format *",
      "barcodeFormatHelp": "Select the type of barcode to display on the card.",
      "qrCodeFormat": "QR Code",
      "barcodeFormatStackedLinear": "Stacked Linear",
      "barcodeFormatBullseye": "Bullseye Pattern",
      "barcodeFormatStandardLinear": "Standard Linear Barcode",
      "platformSpecificImages": "Platform-Specific Images",
      "platformImagesIntro": "These optional images enhance the appearance of your digital cards on specific wallet platforms.",
      "heroImageLabel": "Google Wallet Hero Image",
      "heroImageHelp": "Recommended size: 1032x336px. PNG format. Max 10MB. Displays at the bottom of Google Wallet passes.",
      "fileMaxSize": "The file must be 10MB or less.",
      "currentHeroImage": "Current hero image will be used.",
      "removeHeroImage": "Remove hero image",
      "mainImageLabel": "Google Wallet Main Image",
      "mainImageHelp": "Recommended size: 686x360px. PNG format. Max 10MB. Displays on the back of Google Wallet passes.",
      "currentMainImage": "Current main image will be used.",
      "removeMainImage": "Remove main image",
      "thumbnailLabel": "Apple Wallet Thumbnail",
      "thumbnailHelp": "Recommended size: 200x200px. PNG format. Max 10MB. Displays in the top-right of Apple Wallet passes.",
      "currentThumbnail": "Current thumbnail will be used.",
      "removeThumbnail": "Remove thumbnail",
      "stripImageLabel": "Apple Wallet Strip Image",
      "stripImageHelp": "Recommended size: 1125x372px. PNG format. Max 10MB. Displays across the middle of the card.",
      "currentStripImage": "Current strip image will be used.",
      "removeStripImage": "Remove strip image",
      "customBackFields": "Custom Back of Card Fields",
      "backFieldsIntro": "These are fields that will show up on the back of your digital card.",
      "fieldNumber": "Field {number}",
      "backFieldsInvalidFeedback": "One or more errors are present. Please make sure field labels are 20 characters or less, and that you have at least one wallet option selected.",
      "fieldLabelPlaceholder": "Field Label",
      "fieldContentPlaceholder": "Field Content (text or HTML)",
      "appleWalletOption": "Apple Wallet",
      "googleWalletOption": "Google Wallet",
      "selectCardType": "Please select at least one card type.",
      "addField": "Add Field",
      "cardPreviewMode": "Card Preview Mode",
      "showGoogleHero": "Show Google Wallet Hero",
      "showAppleImage": "Show Apple Wallet Image",
      "noteLabel": "Note:",
      "imageSizesNote": "Image sizes and positioning may vary on the actual membership cards.",
      "logoAlt": "Membership card logo",
      "previewMemberId": "MEMBER ID",
      "previewMemberName": "MEMBER NAME",
      "thumbnailAlt": "Apple Wallet Thumbnail",
      "stripImageAlt": "Apple Wallet Strip Image",
      "previewMembership": "MEMBERSHIP",
      "previewExpiry": "EXPIRY",
      "heroImageAlt": "Google Wallet Hero Image",
      "mainImageAlt": "Google Wallet Main Image",
      "flipCard": "Flip Card",
      "previewDisclaimer": "Note: Actual card might differ slightly from the preview. The preview is for reference only.",
      "logoRequired": "The logo is required.",
      "labelMaxLength": "The label must be 20 characters or less.",
      "labelRequired": "The label is required.",
      "valueRequired": "The value is required.",
      "uploadError": "Something went wrong. Double check the file size is 10MB or less or contact support.",
      "pdf417Barcode": "PDF417 Barcode",
      "aztecCode": "Aztec Code",
      "code128": "Code 128",
      "sampleMemberName": "Joe Smith",
      "sampleMembership": "Community Membership",
      "sampleExpiryDate": "Jan 1, 2025"
    },
    "pdfMembershipCard": {
      "fieldsTab": "Fields",
      "noFieldsAvailable": "No fields available.",
      "qr": "QR",
      "text": "Text",
      "addAsText": "Add as Text",
      "addAsQrCode": "Add as QR Code",
      "removeOverlays": "Remove overlays",
      "noFieldsInGroup": "No fields in this group yet.",
      "selectedOverlaysTab": "Selected overlays",
      "noOverlaysAdded": "No overlays added yet. Choose a field to add it to your card.",
      "oneOverlayAdded": "1 overlay added",
      "overlaysAdded": "{count} overlays added",
      "clearAll": "Clear all",
      "qrCodeBadge": "QR code",
      "overlayNumber": "Overlay #{number}",
      "displayAs": "Display as",
      "qrCodeOption": "QR Code",
      "qrNotAvailable": "QR code not available for this field.",
      "textColor": "Text color",
      "fontSize": "Font size",
      "displayPx": "Display: {value}px",
      "textWidth": "Text width",
      "qrSize": "QR size",
      "margin": "Margin",
      "foregroundColor": "Foreground color",
      "backgroundColor": "Background color",
      "xPosition": "X position",
      "yPosition": "Y position",
      "preview": "Preview",
      "gridSnapping": "Grid snapping",
      "spacing": "Spacing:",
      "changeImage": "Change image",
      "uploadPrompt": "Upload your image to preview your membership card.",
      "uploadImage": "Upload image",
      "userData": "User Data",
      "familyData": "Family Data",
      "profileFields": "Profile Fields",
      "membershipData": "Membership Data",
      "organizationData": "Organization Data",
      "fetchFieldsError": "Something went wrong fetching fields. Please refresh and try again."
    },
    "filterMembership": {
      "match": "Match",
      "matchAll": "All",
      "matchAny": "Any",
      "joinAnd": "AND",
      "joinOr": "OR",
      "show": "Show",
      "and": "and",
      "inactiveAppliesTitle": "Inactive applies to memberships of any type",
      "allUsers": "all users",
      "usersWith": "users with",
      "whoAre": "who are",
      "removeCondition": "Remove condition {number}",
      "statusGroupLabel": "{label} status",
      "expiredBetween": "Expired between",
      "pickRangeBelow": "pick a range below",
      "matchesUsersWhoHave": "Matches users who have",
      "addAnotherCondition": "Add another condition",
      "statusActive": "Active",
      "statusInactive": "Inactive",
      "statusExpired": "Expired",
      "sinceCreation": "Since Creation",
      "anyType": "(any type)",
      "membershipOfAnyType": "membership of any type",
      "readoutActive": "an active {type}",
      "readoutExpiredBetween": "a {type} that expired between {start} and {end}",
      "readoutExpired": "an expired {type}",
      "readoutNoActiveMembership": "no active membership",
      "readoutAnd": "and",
      "readoutOr": "or",
      "chipNoActiveMembership": "No active membership"
    },
    "activeMembersReport": {
      "heading": "Active Memberships",
      "description": "This is the number of memberships assigned across all users. Depending on your set up one user may have multiple memberships. To see the number of Active Members navigate to your",
      "userListLink": "User list",
      "andFilterByActiveStatus": "and filter by Active status.",
      "monthly": "Monthly",
      "yearly": "Yearly",
      "dateRangeWithDates": "Date Range: {startDate} to {endDate}",
      "dateRange": "Date Range",
      "intervalLabel": "Interval: {interval}",
      "typeLabel": "Type: {type}",
      "unknown": "Unknown",
      "membershipTypeAll": "Membership Type: All",
      "chartSeriesLabel": "Active Memberships",
      "tooltipLabel": "Active Memberships: {value}",
      "allMembershipTypes": "All Membership Types",
      "pageTitle": "Active Memberships"
    },
    "membershipCards": {
      "title": "Membership Cards",
      "notificationEmailTitle": "Membership Card Notification Email",
      "notificationIntro": "This message is included in every membership card email that is sent to members, regardless of which specific card configuration is used.",
      "emailSubjectLabel": "Email subject",
      "emailSubjectDescription": "Appears as the subject line for every membership card email.",
      "emailSubjectPlaceholder": "Enter the subject that members will see",
      "availableVariables": "Available variables:",
      "resetToDefault": "Reset to default",
      "pageTitle": "Membership Cards",
      "googleWalletLink": "Google Wallet Link",
      "membershipAreaLink": "Membership Area Link",
      "loadCopyError": "Unable to load notification copy. Please refresh and try again.",
      "notificationCopyEntity": "Notification copy",
      "saveCopyError": "Unable to save notification copy. Please try again."
    },
    "membershipCardsCreate": {
      "modelType": "Membership Card",
      "detailsTitle": "Membership Card Details",
      "nameLabel": "Name *",
      "namePlaceholder": "Enter a name for this membership card",
      "activeStartDateLabel": "Active Start Date *",
      "activeStartDateDescription": "The card will be issued if the user purchases or is assigned a membership within this date range.",
      "fieldRequired": "This field is required.",
      "activeEndDateLabel": "Active End Date *",
      "applicableMembershipsLabel": "Applicable Memberships *",
      "applicableMembershipsDescription": "The card will be issued if the user purchases or is assigned one of these memberships.",
      "requireTemporaryLabel": "Require Temporary Card Data",
      "requireTemporaryDescription": "When enabled, this card can only be generated or refreshed when temporary membership data is supplied.",
      "onlyGenerateWithTemporary": "Only generate with temporary membership data",
      "cardTypeLabel": "Card Type *",
      "cardTypeDescription": "The type of card to issue to the user. When editing an existing card, the type cannot be changed.",
      "cardTypePdf": "PDF",
      "cardTypeDigitalWallet": "Digital Wallet",
      "printLayoutLabel": "Print Layout",
      "printLayoutDescription": "Card Size generates a PDF that matches the card image dimensions. Print Ready (Letter) places the card on a standard US Letter page for easy printing.",
      "printLayoutCardSize": "Card Size",
      "printLayoutLetter": "Print Ready (Letter)",
      "selectImageLabel": "Select Image *",
      "selectImageDescription": "Maximum file size is 10MB.",
      "selectImageInvalidFeedback": "This field is required and must be 10MB or less.",
      "pageTitle": "Create Membership Card",
      "nameRequiredError": "The name is required.",
      "activeStartDateRequiredError": "The active start date is required.",
      "activeEndDateRequiredError": "The active end date is required.",
      "applicableMembershipsRequiredError": "The applicable memberships are required.",
      "selectedFieldsRequiredError": "Without configuring fields the card will be blank.",
      "pdfSavedToast": "Membership Card Saved!",
      "digitalSavedToast": "Digital Membership Card Saved!"
    },
    "modalAutoRenewal": {
      "expires": "Expires",
      "autoRenewalSetting": "Auto-renewal setting",
      "enableDescription": "Enable auto-renewal to charge the card on file automatically when this membership renews.",
      "enableAutoRenewal": "Enable auto-renewal",
      "noCardOnFile": "No card on file",
      "requiresSavedCard": "Auto-renewal requires a saved card. To process a renewal now without a saved card, use",
      "configureEarlyRenewal": "Configure Early Renewal",
      "offlinePaymentSupport": "— it supports offline payment collection.",
      "useEarlyRenewal": "Use Early Renewal",
      "whatWillHappen": "What will happen:",
      "autoRenewalWillBe": "Auto-renewal will be",
      "enabled": "enabled",
      "renewOn": ". The membership will automatically renew on",
      "atNoCharge": "at no charge.",
      "chargedCardOnFile": "and the user's card on file will be charged",
      "disabled": "disabled",
      "endOn": ". The membership will end on",
      "unlessRenewsManually": "unless the user renews it manually before then.",
      "emailConfirmation": "The user will receive an email confirming this change."
    },
    "modalEarlyRenewal": {
      "title": "Early Renewal",
      "renew": "Renew",
      "expires": "Expires",
      "withinRenewalWindow": "Within renewal window",
      "outsideRenewalWindow": "Outside renewal window",
      "freeMembershipNoPayment": "Free membership — no payment required",
      "freeMembershipDescription": "This membership renews at no charge. Submitting will extend the membership without recording a transaction.",
      "chargeCardOnFile": "Charge card on file",
      "noCardOnFile": "No card on file",
      "chargeAmountImmediately": "Charge {amount} immediately",
      "recordOfflinePayment": "Record offline payment",
      "method": "Method",
      "selectMethodPlaceholder": "Select method...",
      "amount": "Amount",
      "whatWillHappen": "What will happen:",
      "renewedEarlyFrom": "Membership will be renewed early from",
      "startingNewTerm": ", starting a new term from today",
      "andExpiringOn": "and expiring on",
      "noPaymentRecorded": "No payment will be recorded.",
      "willBeChargedImmediately": "will be charged to the user's card on file immediately.",
      "offlinePaymentRecorded": "An offline payment of {amount} ({method}) will be recorded.",
      "autoRenewalEnabled": "Auto-renewal is currently enabled and",
      "willRemainEnabled": "will remain enabled",
      "autoRenewalDisabled": "Auto-renewal will remain disabled."
    },
    "modalModifyExpirationDate": {
      "title": "Modify Expiration",
      "expires": "Expires"
    }
  },
  "guest": {
    "membershipIndex": {
      "noMembershipsAvailable": "No memberships available for purchase.",
      "availableMemberships": "Available Memberships"
    }
  }
}
